import MultiPoseAddons from './MultiPoseAddons';

export default MultiPoseAddons;
